document.addEventListener("DOMContentLoaded", function () {
  var sortingOptions = document.querySelectorAll(".sorting-option");
  if (sortingOptions.length) {
    var selectedSortingOptionText = document.querySelector(".selected-sorting_option-text");
  
    sortingOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        const sortValue = this.getAttribute("data-sort-value");

        let queryParams = new URLSearchParams(window.location.search);
        queryParams.set('sort_by', sortValue);

        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            queryParams && '?'.concat(queryParams)
          }`,
        );

        sortingOptions.forEach(function (opt) {
          opt.classList.remove("active");
        });
  
        option.classList.add("active");
        selectedSortingOptionText.textContent = option.textContent;
  
        window.location.href = `${window.location.pathname}${window.location.search}`;
      });
    });
  
  
    let selectedSortingOption= document.querySelector('[js-selected-sorting-option]')
  
    selectedSortingOption.addEventListener('click',function(){
        this.parentElement.classList.toggle('active')
    })
  
    window.addEventListener('click',function(event){
      if (event.target !== selectedSortingOption && !selectedSortingOption.contains(event.target)) {
        selectedSortingOption.parentElement.classList.remove('active')
      }
      
    })
  }
});

const tabBtn = document.querySelectorAll('[js-tab-header]');
if(tabBtn) {
  tabBtn.forEach(button => {
      button.addEventListener('click', (evt) => {
        const tabItem = button.parentElement;
        if (tabItem.classList.contains('open')) {
          tabItem.classList.remove('open')
        }else {
          tabItem.classList.add('open')
        }
      });
  });
}

const cardTabItems = document.querySelectorAll('[js-tab-item]');
if (cardTabItems) {
  const tabPannels =document.querySelectorAll('[js-tab-panel]');
  const closeBtn =document.querySelectorAll('[js-close-icon]');
  
  cardTabItems.forEach((item, index) => {
    item.addEventListener('click', toogleBtn);
    function toogleBtn() {
      cardTabItems.forEach(btn => {btn.classList.remove('active')});
      tabPannels.forEach(btn => {btn.classList.remove('active')});
      this.classList.add('active');
      tabPannels[index].classList.add('active');
      tabPannels[index].parentElement.classList.add('active');
    }
  });
  closeBtn.forEach((button) => {
    button.addEventListener('click', closeDrawer);
    function closeDrawer() {
      this.closest(".beta").classList.remove('active')
      tabPannels.forEach(btn => {btn.classList.remove('active')});
      cardTabItems.forEach(btn => {btn.classList.remove('active')});
   };
  });
}

// order cancelation api fetch

document.addEventListener('DOMContentLoaded', function() {
  var cancelButtons = document.querySelectorAll('.btn-cancel');
  cancelButtons.forEach(button => {
    button.addEventListener('click', function() {
      const order_id = button.getAttribute('order-id');
      const url = 'https://dddemo.net/php/2024/Akshay/Fashor/order_cancellation.php';

      if (order_id) {
        cancelOrder(order_id, url)
      }
    });
  });
});

function cancelOrder(order_id, url) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        orderId: order_id,
        reason: ""
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('order_id >> ', order_id);
    console.log('data hhh >>>', data);
    if(data.data.success){
      // const orderStatusElement = button.closest('.order-status');
      // if (orderStatusElement) {
      //   orderStatusElement.textContent = "Order status: Canceled";
      // }
      setTimeout(() => {
        window.location.href = window.location.href;
      }, 3000);
    }
    
    return data;
  })
  .catch(error => {
    console.error('Error:', error);
    throw error;
  });
}
// end of order cancelation api fetch

// order lineitem delete Api

document.addEventListener('DOMContentLoaded', function () {
  
  ///  fetch all order of the customer
  
  const customerWrap = document.querySelector('.customer-order-wrap');
  if(customerWrap) {
    const customerId = customerWrap.getAttribute('customer-id');  
    function fetchOrders(customerId) {
      console.log("customerWrap ,customerId >>> ",customerWrap ,customerId);
      fetch('https://dddemo.net/php/2024/Akshay/Fashor/get_customer_orders.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "data": {
            "customerId": customerId,
          },
        }),
      })
        .then(response => response.json())
        .then(data => {
          console.log('Orders >>>', data);
          
          data.data.forEach(order => {
            const currentSubtotalAmount = order.node.currentSubtotalPriceSet.presentmentMoney.amount;
            const orderId = order.node.id;
            
            // Find the corresponding order total element and update it
            const orderTotalElement = document.querySelector(`.order-total[full_order_id="${orderId}"]`);
            console.log("orderTotalElement >>> ",orderTotalElement);
            if (orderTotalElement) {
              orderTotalElement.textContent = `Order Total: ₹ ${currentSubtotalAmount}`;
            }
            // Check if all items in the order are deleted (quantity 0)
              const allItemsDeleted = order.node.lineItems.edges.every(lineItem => lineItem.node.currentQuantity === 0);
      
              // If all items are deleted, trigger cancel order button
              if (allItemsDeleted) {
                const cancelOrderButton = document.querySelector(`#cancel-order-btn[full_order_id="${orderId}"]`);
                if (cancelOrderButton) {
                  cancelOrderButton.click(); // Trigger the cancel button
                }
              }            

            order.node.lineItems.edges.forEach(lineItem => {
              const currentQuantity = lineItem.node.currentQuantity;
              const lineItemId = lineItem.node.id;
              const cancelButton = document.querySelector(`.delete__order_item[full_line_id="${lineItemId}"]`);
              if (cancelButton) {
                const btnDelete = cancelButton.closest(".btn_delete");
                console.log("btnDelete >>> ", btnDelete);
                if (btnDelete && currentQuantity === 0) {
                  // Hide the cancel button if current_quantity === 0
                  btnDelete.style.display = "none";
                }
              }
            });
          });
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }

  fetchOrders(customerId);

  //// end of the checking
  
  var deleteButtons = document.querySelectorAll('.delete__order_item');
  deleteButtons.forEach(button => {
    button.addEventListener('click', function () {
      const order_id = button.getAttribute('order_id');
      const line_item_id = button.getAttribute('line_item_id');

      if (order_id && line_item_id) {
        cancelOrderItem(order_id, line_item_id);
      }
    });
  });
  }
  
  
  
    
});

function cancelOrderItem(order_id, line_item_id) {
  fetch('https://dddemo.net/php/2024/Akshay/Fashor/delete_order_item_price.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "data": {
        "orderId": order_id,
        "lineItemId": line_item_id,
      },
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log('data >>>', data);

      if (data.status) {
        setTimeout(() => {
          location.reload();
        }, 2500);
        console.log("data.status >>> ",data.status)
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

// end of order lineitem delete Api

/* track your order API with button click code */

document.addEventListener('DOMContentLoaded', function() {
  const trackOrderButtons = document.querySelectorAll('.custom-links.text.track-order');

  trackOrderButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const order_id = this.getAttribute('order-id');
      fetchOrderStatus(order_id, this);
    });
  });
});

// Function to fetch track order status
function fetchOrderStatus(orderId, button) {
  const requestData = {
    "data": {
      "orderId": orderId
    }
  };

  // console.log("requestData >> ", requestData);

  fetch('https://dddemo.net/php/2024/Akshay/Fashor/get_status.php', {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Origin': 'https://fashor.com',
      'Referer': 'https://fashor.com/',
      'User-Agent': navigator.userAgent
    },
    body: JSON.stringify(requestData)
  })
  .then(response => response.json())
  .then(data => {
    const fulfillments = data.data.order.fulfillments;
    let trackingNumber = fulfillments?.[0]?.trackingInfo?.[0]?.number;

    if (trackingNumber) {
      console.log("Tracking Number >>> ", trackingNumber);
      button.href = `https://fashor.clickpost.in/?waybill=${trackingNumber}&cp_id=5`;
      window.location.href = button.href;
    } else {
      console.error('Tracking number not found');
    }
  })
  .catch(error => console.error('Error:', error));
}

/* END OF track your order API with button click code */

/* exchange and return button code */

document.addEventListener('DOMContentLoaded', function() {
  const exchangeButtons = document.querySelectorAll('.exchange-return-container');

  exchangeButtons.forEach(button => {
    const orderId = button.getAttribute('order-id');
    const requestData = {
      "data": {
        "orderId": orderId
      }
    };
    
    fetch('https://dddemo.net/php/2024/Akshay/Fashor/get_status.php', {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'Origin': 'https://fashor.com',
        'Referer': 'https://fashor.com/',
        'User-Agent': navigator.userAgent
      },
      body: JSON.stringify(requestData)
    })
    .then(response => response.json())
    .then(data => {
      if (data && data.data.order && data.data.order.fulfillments) {
        const fulfillments = data.data.order.fulfillments;
        // Find the fulfillment with status "SUCCESS"
        const successfulFulfillment = fulfillments.find(f => f.status === "SUCCESS");

        if (successfulFulfillment) {
          const updatedAt = new Date(successfulFulfillment.updatedAt);
          const currentDate = new Date();
          const timeDiff = currentDate - updatedAt;
          const daysDiff = timeDiff / (1000 * 3600 * 24);

          if (daysDiff <= 14) {
            button.style.display = "block"; // Show the button if within 14 days
          }
        }
      }
    })
    .catch(error => {
      console.error("Error fetching order data:", error);
    });
  });
});

/* end of exchange and return button code */

/* footer navigator js start */

document.addEventListener("DOMContentLoaded", function () {
  const stickyIcons = document.querySelectorAll(".sticky_icon_menu a");

  // Retrieve active link from localStorage
  const activeLink = localStorage.getItem("activeStickyIcon");

  // Apply active class if there's a stored value
  if (activeLink) {
    stickyIcons.forEach((icon) => {
      if (icon.href === activeLink) {
        icon.classList.add("active");
      }
    });
  }

  stickyIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      // Store clicked link in localStorage
      localStorage.setItem("activeStickyIcon", this.href);
    });
  });
});

function toggleMorePopup() {
  var popup = document.getElementById("morePopup");
  popup.style.display = (popup.style.display === "block") ? "none" : "block";
}

/* footer navigator js end */